<template>
    <main id="main" class="main-site left-sidebar" ref="customization">
        <div class="container">
            <div class="customization">
                <Stepper :steps="this.steps" v-on:next="nextStep" v-on:previous="previousStep" v-model="this.currentStep" />

                <KeepAlive>
                    <ProductListCustomization v-if="this.currentStep == 1" :clear="clearProducts" :shouldRefresh="shouldRefresh" @updateCodigoProduto="(id) => updateCodigoProduto(id)">
                    </ProductListCustomization>
                </KeepAlive>

                <KeepAlive>
                    <ProductCustomization v-if="this.currentStep == 2"
                                          :codigoProduto="currentCodigoProduto"
                                          :produto="currentProduto"
                                          :codigoProjeto="currentCodigoProjeto"
                                          :eventId="eventId"
                                          @removeProduct="(obj) => removeProduct(obj)"
                                          @addProduct="(product) => addProduct(product)"
                                          @voltar="previousStep">
                    </ProductCustomization>
                </KeepAlive>

                <KeepAlive>
                    <Resume v-if="this.currentStep == 3"
                            :products="products"
                            :project="currentCodigoProjeto"
                            :codigoProduto="currentCodigoProduto"
                            @removeProduct="(obj) => removeProduct(obj)"
                            @updateProduct="(id) => updateProduct(id)"
                            @addQtde="(id) => addQtde(id)"
                            @subtractQtde="(id) => subtractQtde(id)"
                            @voltar="previousStep"
                            @novaPersonalizacao="() => novaPersonalizacao(true)"
                            @scrollUp="scrollUp">
                    </Resume>
                </KeepAlive>
            </div>
        </div>
    </main>
</template>

<style scoped>
    .customization {
        margin-top: 40px;
    }

    @media (max-width: 500px) {
        .customization {
            margin-top: 15px;
        }
    }
</style>

<script>
    import ProductListCustomization from '../../components/partials/customization/ProductListCustomization.vue'
    import Resume from '../../components/partials/customization/Resume.vue'
    import ProductCustomization from '../../components/partials/customization/ProductCustomization.vue'

    import Stepper from '@/components/Stepper'

    export default {
        name: 'Customization',
        mounted() {
            this.getSession()
                .success(() => {
                    const url = new URL(location.href)

                    this.currentCodigoProjeto = url.searchParams.get('proj')
                    const codProduto = url.searchParams.get('prod')

                    this.products = JSON.parse(localStorage.getItem('geradoresPeronalizados')) || []

                    if (!Array.isArray(this.products)) this.products = []

                    if (codProduto) {
                        this.currentCodigoProduto = codProduto
                        this.currentStep = 2
                    } else if (this.products.length) {
                        this.currentCodigoProduto = this.products[0].Codigo.split('-')[0];
                        this.currentStep = 3
                    }
                })
                .error((error) => {
                    // Caso não esteja logado, joga para tela de login
                    if (error.status === 401) {
                        swal({
                            title: 'É necessário estar logado',
                            icon: 'warning',
                        }).then(() => (location.href = `${this.$SiteUrl}/login?redirectTo=` + location.href))
                    }
                })
        },

        data() {
            return {
                currentStep: 1,
                steps: [
                    {
                        step: 1,
                        title: 'Selecione o Gerador',
                    },
                    {
                        step: 2,
                        title: 'Personalização',
                    },
                    {
                        step: 3,
                        title: 'Resumo',
                    },
                ],
                products: [],
                currentCodigoProduto: '',
                currentProduto: null,
                clearProducts: 0,
                currentCodigoProjeto: 0,
                eventId: 0,
                shouldRefresh: false,
            }
        },
        components: {
            Stepper,
            ProductListCustomization,
            ProductCustomization,
            Resume,
        },
        methods: {
            scrollUp() {
                this.$refs.customization.scrollIntoView({ behavior: 'smooth' })
            },

            nextStep(step = null) {
                if (step != null) {
                    if (step == 3 && this.products.length > 0) {
                        this.currentStep = step
                        return
                    }
                }

                switch (this.currentStep) {
                    case 1: {
                        if (!this.currentCodigoProduto) return
                        break
                    }
                    case 2: {
                        if (!this.products.length) return
                        break
                    }
                }

                if (this.currentStep < this.steps.length) this.currentStep++

                this.$refs.customization.scrollIntoView({ behavior: 'smooth' })
            },

            previousStep(step = null) {
                if (step != null) {
                    this.currentStep = step
                } else {
                    if (this.currentStep > 1) this.currentStep--
                }

                switch (this.currentStep) {
                    case 1: {
                        this.shouldRefresh = !this.shouldRefresh;
                        break
                    }
                    case 2: {
                        if (!this.currentCodigoProduto && !this.currentProduto) this.currentStep--
                        break
                    }
                }
            },

            updateCodigoProduto(id) {
                this.currentProduto = null
                this.eventId = Math.random(0, 6000000)
                this.currentCodigoProduto = id.toString()
                this.nextStep()
            },

            addProduct(product) {
                this.products = []
                this.products.push(product)

                localStorage.geradoresPeronalizados = JSON.stringify(this.products)

                this.nextStep()
            },

            updateProduct(id) {
                const index = this.products.findIndex((x) => x.id == id)

                if (index != -1) {
                    this.currentProduto = this.products[index]

                    this.currentCodigoProduto = this.currentProduto.Codigo
                    this.currentStep = 2
                }
            },

            removeProduct(obj) {
                const index = this.products.findIndex((x) => x.id == obj.id)

                if (index != -1) {
                    this.products.splice(index, 1)
                }

                if (!this.products.length && (!obj.hasOwnProperty('goToStart') || obj.goToStart)) {
                    this.novaPersonalizacao()
                }

                localStorage.geradoresPeronalizados = JSON.stringify(this.products)
            },

            subtractQtde(id) {
                const index = this.products.findIndex((x) => x.id == id)

                if (index != -1 && this.products[index].qtde > 1) {
                    this.products[index].qtde--
                }

                localStorage.geradoresPeronalizados = JSON.stringify(this.products)
            },

            addQtde(id) {
                const index = this.products.findIndex((x) => x.id == id)

                if (index != -1) {
                    this.products[index].qtde++
                }

                localStorage.geradoresPeronalizados = JSON.stringify(this.products)
            },

            novaPersonalizacao(nova) {
                if (!nova) {
                    this.currentStep = 1
                    this.currentCodigoProduto = ''
                    this.clearProducts++
                    this.$refs.customization.scrollIntoView({ behavior: 'smooth' })
                    return
                }

                swal({
                    title: 'Personalização de um novo gerador',
                    text: 'Ao personalizar um novo gerador, a personalização atual será descartada.\n\nDeseja realmente continuar?',
                    buttons: ['Não', 'Sim'],
                    dangerMode: true,
                }).then((novo) => {
                    if (novo) {
                        localStorage.removeItem('geradoresPeronalizados')
                        this.currentStep = 1
                        this.currentCodigoProduto = ''
                        this.clearProducts++
                        this.$refs.customization.scrollIntoView({ behavior: 'smooth' })
                    }
                })
            },

            getSession() {
                return $.ajax({
                    url: this.$apiUrl + 'Session.svc/getsessions',
                    dataType: 'json',
                    type: 'GET',
                    xhrFields: { withCredentials: true },
                })
            },
        },
    }
</script>
